import React from "react";
import { Button } from "reactstrap";

const CustomToolbar = (props) => {
  const { action, selectedRowsCount, cancelAction } = props;

  return (
    <React.Fragment>
      {/* Add button is always visible */}
      {action && (
        <Button className="btn-rounded" color="info" onClick={action}>
          <span className="align-middle">Add</span>
        </Button>
      )}
    </React.Fragment>
  );
};

const CustomToolbarSelect = (props) => {
  const { selectedRowsCount, cancelAction } = props;

  // Only show Cancel button when there are selected items
  if (!cancelAction || !selectedRowsCount || selectedRowsCount === 0) {
    return null;
  }

  return (
    <React.Fragment>
      <Button 
        className="btn-rounded"
        color="danger" 
        onClick={cancelAction}
        style={{ marginRight: "1.5rem" }}
      >
        <span className="align-middle">Cancel ({selectedRowsCount})</span>
      </Button>
    </React.Fragment>
  );
};

export default CustomToolbar;
export { CustomToolbarSelect };
